import { Button, Dialog, DialogContentText } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { Dispatch, ReactElement, SetStateAction, createContext, useContext, useState } from 'react';

const UpdateDialogContext = createContext(null);

interface DialogProps {
    title: string | ReactElement,
    content: string | ReactElement
};

export const useDialogContext: () => Dispatch<SetStateAction<DialogProps>> = () => useContext(UpdateDialogContext);

export const DialogContextProvider = ({ children }) => {

    const [dialog, setDialog] = useState<DialogProps & { open?: boolean }>({
        title: '',
        content: '',
        open: false,
    });

    const closeDialog = () => setDialog({
        ...dialog,
        open: false,
    });

    const openDialog = (props: DialogProps) => {
        setDialog({
            ...props,
            open: true
        });
    };

    return (
        <UpdateDialogContext.Provider value={openDialog}>
            <React.Fragment>
                {children}
                <Dialog
                    open={dialog.open}
                    fullWidth={true}
                    maxWidth="xs"
                >
                    <DialogTitle>{dialog.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {dialog.content}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                closeDialog();
                                window.close();
                            }}
                        >
                            Chiudi
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        </UpdateDialogContext.Provider>
    );
};
